(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tce-approved-home"] && !Shopify.designMode) return;
  try {
    
function initCustomEdit(){
 const root=document.getElementById('tce-real');
 if(!root||root.dataset.tceInitialized)return;
 root.dataset.tceInitialized='true';
 const trigger=root.querySelector('[data-panel="search"]');
 const panel=root.querySelector('#tce-panel-search');
 const field=root.querySelector('#tce-query');
 const drop=root.querySelector('.menu-drop');
 function closeSearch(){panel.hidden=true;trigger.setAttribute('aria-expanded','false');}
 trigger.addEventListener('click',()=>{panel.hidden=!panel.hidden;trigger.setAttribute('aria-expanded',String(!panel.hidden));if(!panel.hidden){drop.open=false;field.focus();}});
 panel.querySelector('.close-panel').addEventListener('click',()=>{closeSearch();trigger.focus();});
 root.addEventListener('keydown',e=>{if(e.key==='Escape'){if(!panel.hidden){closeSearch();trigger.focus();}if(drop.open){drop.open=false;drop.querySelector('summary').focus();}}});
 root.querySelectorAll('.menu-list a').forEach(a=>a.addEventListener('click',()=>drop.open=false));
 document.addEventListener('click',e=>{if(!drop.contains(e.target))drop.open=false;});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initCustomEdit);}else{initCustomEdit();}
document.addEventListener('shopify:section:load',initCustomEdit);

  } catch(e) { console.error(e); }
})();
})();
